import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class UtilitarioService {
  
  loading:Boolean = false;
  constructor(
    private toastrService:ToastrService,
    private router:Router,
    ) { }

  toastrInfo(mensaje:String){
    this.toastrService.info(mensaje.toString());
  }
  toastrSuccess(mensaje:String){
    this.toastrService.success(mensaje.toString());
  }
  toastrWarning(mensaje:String){
    this.toastrService.warning(mensaje.toString());
  }
  toastrError(mensaje:String){
    this.toastrService.error(mensaje.toString());
  }
  
  fc_verificar_storagesessionAdmin(){
    var idtoken = localStorage.getItem('c_usuario');    
    if (idtoken == 'undefined' || idtoken == null || idtoken == ""){
      this.router.navigate(['']);
    }
  }

  fcSalirAdmin(){    
    localStorage.setItem("c_usuario","");
    localStorage.setItem("c_organo","");    
    localStorage.setItem("c_perfil", "");
    localStorage.setItem("x_nombres", "");
    
    this.router.navigate(['']);
  }

}
